import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-common-destination-select',
  templateUrl: './help-common-destination-select.component.html'
})
export class HelpCommonDestinationSelectComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
